module.exports = __webpack_public_path__ + "static/media/savi-logo.87610d39.svg";